import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import '@/App.css';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import SelectedWork from './components/SelectedWork';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import HowItWorks from './components/HowItWorks';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import StartProjectForm from './components/StartProjectForm';
import AdminDashboard from './components/AdminDashboard';
import TermsOfService from './components/TermsOfService';
import FAQ from './components/FAQ';

// Home Page
const Home = () => {
  return (
    <>
      <Hero />
      <SelectedWork />
      <Services />
      <Testimonials />
      <About />
      <HowItWorks />
      <FinalCTA />
    </>
  );
};

// Start Project Page
const StartProject = () => {
  return <StartProjectForm />;
};

// Admin Page (no header/footer)
const Admin = () => {
  return <AdminDashboard />;
};

function App() {
  // Initialize Lenis smooth scrolling
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-background min-h-screen">
      <BrowserRouter>
        <Routes>
          {/* Admin route - no header/footer */}
          <Route path="/admin" element={<Admin />} />
          
          {/* Public routes with header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/start-project" element={<StartProject />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/faq" element={<FAQ />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
